<template>
  <div class="d-flex justify-content-between p-3 p-md-4">
    <div>
      <i class="fad fa-envelope-open"></i>
      <a
        class="pl-1"
        :href="`mailto:${email}`"
        style="color: #444; background-color: #fff"
        :data-gtm-name="
          utmCampaign === 'login'
            ? 'login_yektanet_email'
            : 'logout_yektanet_email'
        "
      >
        {{ email }}
      </a>
    </div>
    <div>
      <i class="fad fa-phone"></i>
      <a
        :class="['pl-1', { fanum: $i18n.locale === 'fa' }]"
        href="tel:02145195000"
        style="color: #444; background-color: #fff"
        :data-gtm-name="
          utmCampaign === 'login'
            ? 'login_yektanet_phone'
            : 'logout_yektanet_phone'
        "
      >
        021-45195000
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    email: {
      type: String,
      required: true,
    },
    utmCampaign: {
      type: String,
      required: true,
    },
  },
};
</script>

<style></style>
